export default __webpack_public_path__ + "static/media/weight_male@2x.9331fafe.png";